import { kebabCase } from 'lodash';

export const SHOP_SECTIONS = [
  { key: 'outfit', label: 'Outfits' },
  { key: 'backpack', label: 'Back Blings' },
  { key: 'pickaxe', label: 'Pickaxes' },
  { key: 'emote', label: 'Emotes' },
  { key: 'glider', label: 'Gliders' },
  { key: 'wrap', label: 'Wraps' },
  { key: 'contrail', label: 'Contrails' },
  { key: 'loadingscreen', label: 'Loading Screens' },
  { key: 'shoe', label: 'Kicks' },
  { key: 'sidekick', label: 'Sidekicks' },
  { key: 'other', label: 'More' },
];

export const SECTION_BRUSH = '/assets/section-brush.png';

export const SECTION_ICONS = {
  outfit: { src: '/assets/section-icons/outfit.png', width: 55, height: 47 },
  backpack: { src: '/assets/section-icons/backpack.png', width: 41, height: 46 },
  pickaxe: { src: '/assets/section-icons/pickaxe.png', width: 51, height: 50 },
  emote: { src: '/assets/section-icons/emote.png', width: 47, height: 52 },
  glider: { src: '/assets/section-icons/glider.png', width: 50, height: 50 },
  wrap: { src: '/assets/section-icons/wrap.png', width: 50, height: 50 },
  contrail: { src: '/assets/section-icons/contrail.png', width: 50, height: 46 },
  shoe: { src: '/assets/section-icons/shoe.png', width: 45, height: 47 },
  sidekick: { src: '/assets/section-icons/sidekick.png', width: 53, height: 50 },
};

export const SECTION_FALLBACK_ICONS = {
  loadingscreen: '🖼',
  other: '📦',
};

export function mapCosmetic(item) {
  const type = item.type?.value || item.type || '';

  return {
    id: item.id || kebabCase(item.name),
    name: item.name,
    description: item.description || '',
    imageUrl: item.images?.icon || item.images?.smallIcon || '',
    rarity: (item.rarity?.value || item.rarity || 'common').toLowerCase(),
    category: type === 'emote' ? 'emotes' : type,
    price: item.price,
  };
}

export function getLastShopDate(shopHistory = []) {
  if (!shopHistory.length) return null;

  return shopHistory[shopHistory.length - 1];
}

export function formatLastSeen(isoDate) {
  if (!isoDate) return '';

  const date = new Date(isoDate).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

  return `Last seen ${date}`;
}

export async function fetchCosmeticLastSeen(cosmeticId) {
  if (!cosmeticId) return null;

  const response = await fetch(
    `https://fortnite-api.com/v2/cosmetics/br/${encodeURIComponent(cosmeticId)}?responseFlags=4`
  );
  const { data } = await response.json();

  return getLastShopDate(data?.shopHistory);
}

export function mapShopCosmetic(item, vBucks) {
  const type = item.type?.value || item.type || '';

  return {
    manifestId: item.id,
    name: item.name,
    id: item.id || kebabCase(item.name),
    rarity: (item.rarity?.value || item.rarity || 'common').toLowerCase(),
    category: type === 'emote' ? 'emotes' : type,
    section: type === 'emote' ? 'emote' : (type || 'other'),
    imageUrl: item.images?.icon || item.images?.smallIcon || '',
    vBucks,
  };
}

function getDisplayImage(entry, brItem) {
  const brItems = entry.brItems || [];

  if (brItems.length === 1) {
    const renderImage = entry.newDisplayAsset?.renderImages?.[0]?.image;
    if (renderImage) return renderImage;
  }

  return brItem?.images?.icon || brItem?.images?.smallIcon || '';
}

export function parseShopEntries(entries = []) {
  const items = [];

  entries.forEach((entry) => {
    const brItems = entry.brItems || [];
    if (brItems.length !== 1) return;

    const brItem = brItems[0];
    const mapped = mapShopCosmetic(brItem, entry.finalPrice);
    mapped.shopKey = entry.offerId;
    mapped.imageUrl = getDisplayImage(entry, brItem) || mapped.imageUrl;
    mapped.isNew = entry.banner?.value === 'New' || entry.offerTag?.text === 'New';
    mapped.lastSeen = getLastShopDate(brItem.shopHistory);

    if (!SHOP_SECTIONS.some((section) => section.key === mapped.section)) {
      mapped.section = 'other';
    }

    items.push(mapped);
  });

  return items;
}

export function groupShopSections(items = []) {
  const grouped = items.reduce((acc, item) => {
    const key = item.section || 'other';
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});

  return SHOP_SECTIONS
    .map(({ key, label }) => ({ key, label, items: grouped[key] || [] }))
    .filter((section) => section.items.length > 0);
}

export async function searchCosmetics(query) {
  if (!query || query.length < 3) return [];

  const response = await fetch(
    `https://fortnite-api.com/v2/cosmetics/br/search/all?name=${encodeURIComponent(query)}&matchMethod=contains`
  );
  const { data = [] } = await response.json();

  return data.map(mapCosmetic);
}
